import { useMemo, ReactNode } from "react";
import { useGetUser } from "@hooks/useGetUser";
import { UserContext } from "@contexts/UserContext";

interface UserProviderProps {
  children: ReactNode;
}

export const UserProvider: React.FC<UserProviderProps> = ({
  children,
}: UserProviderProps) => {
  const { data, isLoading } = useGetUser();

  const value = useMemo(
    () => ({
      user: data?.user || null,
      finishedWalkthroughs: data?.finishedWalkthroughs || [],
      isLoading,
    }),
    [data, isLoading]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
